var _path, _path2, _path3, _path4, _circle, _circle2, _circle3, _path5, _rect, _rect2, _rect3, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisionIcon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 70,
    viewBox: "0 0 61 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25456 47.7419C10.6772 47.7419 50.0387 47.7419 54.4614 47.7419C58.884 47.7419 63.3066 69.8552 58.884 69.8552C54.4614 69.8552 46.0583 61.231 40.1983 61.231C34.3383 61.231 34.3383 65.4325 30.358 65.4325C26.3776 65.4325 26.1565 61.231 20.5176 61.231C14.8787 61.231 6.25456 69.8552 1.83192 69.8552C-2.59072 69.8552 1.83192 47.7419 6.25456 47.7419Z",
    fill: "url(#paint0_linear_139_970)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.46606 46.6497C8.46606 46.6497 8.46606 44.6465 15.3212 44.6465C22.1763 44.6465 22.1763 46.6497 22.1763 46.6497V47.7423H8.46606V46.6497Z",
    fill: "#2D0066"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9822 46.6497C38.9822 46.6497 38.9822 44.6465 45.8373 44.6465C52.6924 44.6465 52.6924 46.6497 52.6924 46.6497V47.7423H38.9822V46.6497Z",
    fill: "#2D0066"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9816 54.3756C38.9816 56.0854 35.0214 58.1349 30.1363 58.1349C25.2512 58.1349 21.291 56.0854 21.291 54.3756C21.291 54.3756 25.2512 53.9333 30.1363 53.9333C35.0214 53.9333 38.9816 54.3756 38.9816 54.3756Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.1824,
    cy: 22.0054,
    r: 11.8172,
    fill: "#090C32"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.1824,
    cy: 22.0059,
    r: 10.8718,
    fill: "#A60183"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.183,
    cy: 22.0051,
    r: 9.92645,
    fill: "#300168"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2911 26.9998C29.738 26.9998 29.2151 26.9098 28.7223 26.7299C28.2349 26.545 27.8078 26.2851 27.441 25.9503C27.0631 25.6055 26.7702 25.1982 26.5621 24.7284C26.354 24.2586 26.25 23.7464 26.25 23.1917V20.8079C26.25 20.2531 26.354 19.7409 26.5621 19.2711C26.7702 18.8014 27.0631 18.3941 27.441 18.0492C27.8078 17.7144 28.2349 17.457 28.7223 17.2771C29.2151 17.0922 29.738 16.9998 30.2911 16.9998C31.0905 16.9998 31.8024 17.1722 32.4266 17.517C32.8975 17.7769 33.3273 18.1617 33.7161 18.6714C33.8694 18.8763 33.9461 19.0962 33.9461 19.3311C33.9461 19.591 33.8393 19.8183 33.6258 20.0132C33.4013 20.2082 33.1275 20.3056 32.8044 20.3056C32.6456 20.3056 32.5005 20.2756 32.3691 20.2156C32.2377 20.1557 32.1309 20.0682 32.0488 19.9533C31.9119 19.7584 31.8024 19.6134 31.7202 19.5185C31.6436 19.4235 31.5477 19.3411 31.4328 19.2711C31.2904 19.1862 31.1289 19.1237 30.9482 19.0837C30.7729 19.0387 30.5539 19.0162 30.2911 19.0162C29.7599 19.0162 29.3328 19.1562 29.0098 19.436C28.6374 19.7609 28.4512 20.2131 28.4512 20.7929V23.2067C28.4512 23.7864 28.6374 24.2386 29.0098 24.5635C29.3328 24.8433 29.7599 24.9833 30.2911 24.9833C30.7948 24.9833 31.2055 24.8858 31.5231 24.6909C31.66 24.606 31.7832 24.506 31.8927 24.3911C32.0022 24.2761 32.1117 24.1362 32.2213 23.9713V23.2441H31.5806C31.4328 23.2441 31.2931 23.2191 31.1617 23.1692C31.0303 23.1142 30.9153 23.0417 30.8167 22.9518C30.7182 22.8618 30.6415 22.7569 30.5868 22.6369C30.532 22.512 30.5046 22.3796 30.5046 22.2396C30.5046 22.1097 30.532 21.9848 30.5868 21.8648C30.6415 21.7399 30.7182 21.6299 30.8167 21.535C30.9153 21.445 31.0303 21.3751 31.1617 21.3251C31.2931 21.2701 31.4328 21.2426 31.5806 21.2426L33.1494 21.2576C33.2972 21.2576 33.4369 21.2851 33.5683 21.3401C33.7052 21.3901 33.8256 21.46 33.9297 21.55C34.1432 21.7449 34.25 21.9748 34.25 22.2396V23.8588C34.25 23.9788 34.2418 24.1062 34.2254 24.2411C34.2089 24.3961 34.1816 24.511 34.1432 24.586C33.7873 25.3506 33.2671 25.9478 32.5826 26.3776C31.9201 26.7924 31.1562 26.9998 30.2911 26.9998Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23.6445,
    y: 3.08423,
    width: 1.35219,
    height: 5.40878,
    rx: 0.676097,
    fill: "#300168"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30.406,
    y: 0.379883,
    width: 1.35219,
    height: 6.76097,
    rx: 0.676097,
    fill: "#300168"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 37.1663,
    y: 3.08423,
    width: 1.35219,
    height: 5.40878,
    rx: 0.676097,
    fill: "#300168"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20 36.3989C20 36.0736 20.1339 35.7648 20.3884 35.5621C21.5638 34.6259 25.3228 31.9998 30.5 31.9998C35.6772 31.9998 39.4362 34.6259 40.6116 35.5621C40.8661 35.7648 41 36.0736 41 36.3989C41 37.4067 39.7552 38.0057 38.9076 37.4607C36.9582 36.2073 33.8547 34.6442 30.5 34.6442C27.1453 34.6442 24.0418 36.2073 22.0924 37.4607C21.2448 38.0057 20 37.4067 20 36.3989Z",
    fill: "#2D0066"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_139_970",
    x1: 30.358,
    y1: 47.7419,
    x2: 30.358,
    y2: 69.8552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F007A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8008F"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisionIcon1);
export default __webpack_public_path__ + "static/media/vision_icon1.1fc7e05680a004a0a1b65cdc3c76091d.svg";
export { ForwardRef as ReactComponent };